import { render, staticRenderFns } from "./NewEdit.vue?vue&type=template&id=6ab678f4&"
import script from "../../models/push-notifications/new-edit.ts?vue&type=script&lang=ts&"
export * from "../../models/push-notifications/new-edit.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports